/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState, useRef, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, Box, Modal, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import '../../component/multi-industry/index.scss';
import Color from '@tool/color';
import { CloseIcon20, CloseIcon } from '@styled/icon';
import {
  DButton, EButton, ChooseButton,
} from '../../../../component/styled/index';
import moCityStore, { toggleModal, changeCity } from './city-store';

interface IProps {}
interface IState {}

const DModal = styled(Modal)(() => ({
  zIndex: 5555555,
}));

const CloseIconButton = styled(IconButton)(() => ({}));

const SureButton = styled(Button)(() => ({
  width: '80px',
  height: '36px',
  borderRadius: '18px',
  fontSize: '14px',
  lineHeight: 1.5,
  fonWeight: 500,
  color: Color.fff,
  backgroundColor: Color.secondary,

  '&:hover': {
    color: Color.fff,
    backgroundColor: Color.secondary,
  },
}));

const LineBox = styled(Box)(() => ({
  display: 'inline-flex',
  justifyContent: 'flex-end',
  padding: '10px 20px',
  borderTop: `1px solid ${Color.blackColor(0.08)}`,
}));

const City = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const subRef = useRef(null);
  const { list, isModal } = moCityStore;

  useEffect(() => {
    return () => {};
  }, []);

  const onNothing = () => {};

  return (
    <DModal open={isModal} onClose={() => onNothing()}>
      <section className="industry-modal_0110">
        <section className="title-015" style={{ paddingRight: '20px' }}>
          <span>选择城市</span>
          <CloseIconButton onClick={() => toggleModal(false)}>
            <CloseIcon20 color={Color.blackColor(0.65)} />
          </CloseIconButton>
        </section>
        <section className="modal-0111">
          <section className="industry-0201" style={{ padding: 0 }}>
            {list?.map((item: any, index: number) => (
              <section key={index} className="item-111">
                <EButton key={index} onClick={() => changeCity(item.code, item.active)}
                  className={item.active ? 'active' : ''}>{item.name}
                </EButton>
              </section>
            ))}
          </section>
        </section>
        <LineBox>
          <SureButton onClick={() => toggleModal(false)}>确定</SureButton>
        </LineBox>
      </section>
    </DModal>
  );
};

export default observer(City);
